import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import AllotmentDetailView from './AllotmentDetailView';
import crmServices from '../../wsclient/'
import { getConditionContentByAllotment, getCurrency } from '../../utils/common';

const styles = theme => ({

});

function AllotmentDetail(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [params, setParams] = useState(null);
    const [wallet_info, setWalletInfo] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [tabSelected, setTabSeleted] = useState(1);
    const [transactionDetail, setTransactionDetail] = useState(null);
    const [showDetail, onShowDetail] = useState(false);

    useEffect(() => {
        onLoadWalletInfo();
        onLoadTransactions();
    }, []);

    const onChangeSwitch = (index) => {
        setTabSeleted(index)
        if (index == 1) {
            onLoadWalletInfo();
        } else {
            onLoadTransactions();
        }
    }
    const onLoadWalletInfo = async (isRefesh) => {
        onShowLoading(true);
        let wallet = props.wallet;
        let new_params = { ...params }
        new_params.walletId = wallet.id
        setParams(new_params);

        try {
            let result = await crmServices.account.getWaleltBalances({ ...new_params });
             console.log('getWaleltBalances== ',result)
            if (result.code == 'OK') {
                setWalletInfo(result.data)
            }
        } catch (error) {
            console.log("on load wallet info error:", error);
        }
        onShowLoading(false);
    }

    const handleLoadMore = async () => {
        onShowLoadMore(true);

        let new_params = { ...params }
        new_params.page = new_params.page + 1
        new_params.size = 10
        setParams(new_params);

        try {
            let result = await crmServices.account.getWaleltBalances({ ...new_params });
            // console.log('getWaleltBalances== ',result)
            if (result.code == 'OK') {
                setWalletInfo([...wallet_info, ...result.data])
                if (result.data.content.length === 0)
                    setHasMore(false);
            }
        } catch (error) {
            console.log("on load wallet info error:", error);
        }
        onShowLoadMore(false);
    }

    const createConditionContent = (allotments) => {
        let data = [];
        if (allotments.length == 0) {
            return data;
        }
        allotments.forEach(element => {
            let conditionText = getConditionContentByAllotment(element);
            element.conditionText = conditionText;
            data.push(element);
        });
        return data;
    }

    const onLoadTransactions = async () => {
        onShowLoading(true);
        try {
            var result = await crmServices.account.getWaleltJournal();
            if (result.code == 'OK') {
                setTransactions(result.data && result.data.content ? result.data.content : []);
            }
        } catch (error) {
            console.log("load wallet journals transactions error:", error);
        }
        onShowLoading(false);
    }

    const onClickDetail = (item) => {
        if (transactionDetail && transactionDetail.id && item.id === transactionDetail.id) {
            onShowDetail(!showDetail)
        }
        else {
            setTransactionDetail(item);
            onShowDetail(true);
        }
    }
    console.log("currency: ", props.currency)
    return (
        <div>
            <AllotmentDetailView
                showLoading={showLoading}
                open={props.open}
                tabSelected={tabSelected}
                transactions={transactions}
                transactionDetail={transactionDetail}
                showDetail={showDetail}
                wallet_info={createConditionContent(wallet_info && wallet_info.content ? wallet_info.content : [])}
                currency={getCurrency()}
                onCloseAllotment={props.onCloseAllotment}
                hasMore={hasMore}
                showLoadMore={showLoadMore}
                setTabSeleted={setTabSeleted}
                onClickDetail={onClickDetail}
                onChangeSwitch={onChangeSwitch}

                handleLoadMore={handleLoadMore} />
        </div>
    );
}


export default withStyles(styles)(withTranslation()(AllotmentDetail));